/**
 * The only mock left in the Comm Center: a stand-in project used by the
 * component gallery (pages/DevComponents) to preview the Brief tab without a
 * real project loaded. Everything else now comes from the API — see
 * adapters.js for the mapping and constants.js for the vocabulary.
 */

/**
 * Stand-in project for the Brief tab, used where no real project is loaded
 * (component previews).
 */
export const MOCK_BRIEF = {
    id: 'mock-p1',
    client: 'Gino Basile',
    brief: `## Tono generale

Un film intimo, girato quasi tutto in interni. La musica deve **stare sotto**, mai commentare:
niente temi eroici, niente archi che spiegano l'emozione.

### Riferimenti
- *Lo spazio bianco* — pianoforte preparato, molto asciutto
- *Le conseguenze dell'amore* — synth analogici, pochissime note

### Da evitare
1. Percussioni ritmiche nelle scene di dialogo
2. Crescendo sui finali di sequenza
3. Cori

> Il cliente ha chiesto esplicitamente di provare una versione senza musica sul finale.

Consegna della prima selezione entro **due settimane** dalla firma.`,
};
